<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex
        :key="i"
        pa-2
        v-for="(sprint, i) in sprints"
      >
        <sprint-card :sprint="sprint"></sprint-card>
      </v-flex>
    </v-layout>
    <v-btn
      @click="goToAdd"
      bottom
      fab
      fixed
      right
      id="addSprintButton"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
import SprintCard from '@/components/SprintCard.vue';

export default {
  name: 'SprintsView',
  components: { SprintCard },
  computed: {
    sprints() {
      return this.$store.getters.getSprints;
    },
  },
  methods: {
    goToAdd() {
      this.$router.push({ name: 'Add Sprint' });
    },
  },
};

</script>
